import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendTelegramMessage } from '../../reducers/telegram/telegram-action';
import './MediaFileView.css';
import { API_GET_IMG_URL, API_UPLOAD_FILE } from '../../api/chat.service';
import { InputText } from 'primereact/inputtext';
import { ReactComponent as SendButton } from '../../assets/svgIcons/svgIcons/sendbuttonicon.svg';

const MediaFileView = ({ file, setFileselected }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [text, setText] = useState('');

  const dispatch = useDispatch();
  const { selectedBotConfigId, selectedContact } = useSelector((state) => state.telegram);

  const selectedFile = Array.isArray(file) ? file[0] : file;

  useEffect(() => {
    if (!selectedFile?.data) return;

    const url = URL.createObjectURL(selectedFile.data);
    setPreviewUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [selectedFile]);

  if (!selectedFile) return null;

  async function handleSend() {
    if (!selectedFile?.data || !selectedContact?.chatId || !selectedBotConfigId) {
      return;
    }

    try {
      /* 1️⃣ Get presigned upload URL */
      const resp = await API_GET_IMG_URL(); // ✅ SAME as multi-file
      const uploadUrl = resp.data.src;
      const fileUrl = resp.data.url;

      console.log('resp', resp);
      console.log('selectedFile', selectedFile);

      /* 2️⃣ Upload file */
      await API_UPLOAD_FILE(uploadUrl, selectedFile.data, {
        headers: {
          'Content-Type': selectedFile.data.type,
        },
      });

      /* 3️⃣ Build Telegram payload */
      let payload;

      switch (selectedFile.type) {
        case 'image':
          payload = {
            type: 'photo',
            message: {
              chat_id: selectedContact.chatId,
              photo: fileUrl,
              caption: text || '',
            },
          };
          break;

        case 'video':
          payload = {
            type: 'video',
            message: {
              chat_id: selectedContact.chatId,
              video: fileUrl,
              caption: text || '',
            },
          };
          break;

        default:
          payload = {
            type: 'document',
            message: {
              chat_id: selectedContact.chatId,
              document: fileUrl,
              caption: text || '',
            },
          };
          break;
      }

      console.log('payload', payload);

      /* 4️⃣ Send message */
      await dispatch(
        sendTelegramMessage({
          botConfigId: selectedBotConfigId,
          chatId: selectedContact.chatId,
          payload,
        }),
      ).unwrap();

      console.log('Telegram Payload Sent:', payload);
      setFileselected(null);
    } catch (error) {
      console.error('Upload / Send failed:', error);
    }
  }

  const addCaption = (e) => {
    setText(e.target.value);
  };

  return (
    <div className="mfv-overlay">
      <button className="mfv-close" onClick={() => setFileselected(null)}>
        ✕
      </button>

      <div className="mfv-preview">
        {selectedFile.type === 'video' ? (
          <video src={previewUrl} controls />
        ) : (
          <img src={previewUrl} alt={selectedFile.data.name} />
        )}
      </div>

      <div className="mfv-filename">{selectedFile.data.name}</div>

      <div className="mfv-bottom">
        <InputText
          className="w-12 textInput"
          type="text"
          placeholder="Type a message"
          onChange={addCaption}
          value={text}
        />
        <button onClick={handleSend} className="spinerButton">
          <SendButton />
        </button>
      </div>
    </div>
  );
};

export default MediaFileView;
